<template>
    <div>
        <form-row title="Total Earnest Money Being Held" :no_border="true" class="my-6">
            <input-money
                name="total_earnest_money_held"
                :value="total_held"
                :read_only="true"
                tabindex="-1"
            />
        </form-row>

        <div class="border-b border-gray-400"></div>
    </div>
</template>

<script>
export default {
    props: {
        total_held: {},
        read_only: { default: false },
    },
}
</script>
